import { render, staticRenderFns } from "./ChatDrawer.vue?vue&type=template&id=1832bba0"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports